import { render, staticRenderFns } from "./ItemMarkets.vue?vue&type=template&id=633447da&"
import script from "./ItemMarkets.vue?vue&type=script&lang=js&"
export * from "./ItemMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports